import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import News from "@/pages/News";
import ArticlePage from "@/pages/ArticlePage";
import Pricing from "@/pages/Pricing";
import Research from "@/pages/Research";
import ReportDetail from "@/pages/ReportDetail";
import Sponsor from "@/pages/Sponsor";
import Support from "@/pages/Support";
import { Login, Register } from "@/pages/Auth";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import Events from "@/pages/Events";
import Agap from "@/pages/Agap";

const Protected = ({ children, admin }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-[60vh] flex items-center justify-center overline text-[#5C5449]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/account" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Header />
        <main className="min-h-[70vh]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/news" element={<News />} />
            <Route path="/article/:slug" element={<ArticlePage />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/research" element={<Research />} />
            <Route path="/research/:slug" element={<ReportDetail />} />
            <Route path="/sponsor" element={<Sponsor />} />
            <Route path="/events" element={<Events />} />
            <Route path="/agap" element={<Agap />} />
            <Route path="/support" element={<Support />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/account" element={<Protected><Account /></Protected>} />
            <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
